import { render, staticRenderFns } from "./PPagination.vue?vue&type=template&id=6f5b903f&scoped=true&"
import script from "./PPagination.vue?vue&type=script&lang=ts&"
export * from "./PPagination.vue?vue&type=script&lang=ts&"
import style0 from "./PPagination.vue?vue&type=style&index=0&id=6f5b903f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5b903f",
  null
  
)

export default component.exports